import React from "react"
import FieldProto from "../proto/field-proto";

export type FieldViewReferenceProps = {
    field       : FieldProto
    model       : any
    // options?    : any
    className?  : string
    // onClick?    : onClick
};

export default function FieldViewReference(props:FieldViewReferenceProps):React.ReactElement {

    return <props.field.renderComponents.viewReference {...props} />

}